// Campus photo for /colleges/university-of-denver: CC BY-SA 4.0, by DenverLawGuy, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ADaniel_L._Ritchie_Center_for_Sports_and_Wellness.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-denver/; credited under the photo.
const photo = {
    "slug": "university-of-denver",
    "alt": "The Ritchie Center bell tower and the soccer stadium at the University of Denver in Denver, Colorado",
    "src": "/colleges/university-of-denver/campus-1600.webp",
    "srcSmall": "/colleges/university-of-denver/campus-800.webp",
    "srcMid": "/colleges/university-of-denver/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-denver/og.jpg",
    "title": "Daniel L. Ritchie Center for Sports and Wellness",
    "author": "DenverLawGuy",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ADaniel_L._Ritchie_Center_for_Sports_and_Wellness.jpg",
    "read": "2026-10-02"
};

export default photo;
